<template>
    <relatorio-page titulo="Relação de Compromissos" :cabecalhoCompleto="true" :exportarExcel="true" :paisagem="true" :fonteVariavel="true">
        <v-simple-table id="tabela" dense class="py-2 text-caption fonte">
            <template v-slot:default>
                <thead class="compromisso-thead" style="background-color: #4A70A8">
                    <tr>
                        <th style="font-size: 100% " class="text-left fonte">Cód.</th>
                        <th style="font-size: 100% ; width: 450px" class="text-center fonte">Fornecedor</th>
                        <th style="font-size: 100% " class="text-center">Sit.</th>
                        <th style="font-size: 100% " class="text-center">Vencimento</th>
                        <th style="font-size: 100% " class="text-center">Pagamento</th>
                        <th style="font-size: 100% " class="text-center">Desconto</th>
                        <th style="font-size: 100% " class="text-center">Juros</th>
                        <th style="font-size: 100% " class="text-center">Total</th>
                        <th style="font-size: 100% " class="text-center">Forma Pgt.</th>
                        <th style="font-size: 100% " class="text-center">Cód.</th>
                        <th style="font-size: 100% " class="text-center">Projeto</th>
                        <th style="font-size: 100% ; width: 450px" class="text-center">Descrição</th>
                    </tr>
                </thead>
                <tbody class="fonte">
                    <tr v-for="(item, index) in item.compromissos" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                        <td style="font-size: 100% " class="text-left">{{ item.codigo }}</td>
                        <td style="font-size: 100% ; width: 400px" class="text-center">{{ item.fornecedor }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.situacao }}</td>
                        <td style="font-size: 100% " class="text-center">{{ new Date(item.dataVencimento).ddmmyyyy() }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : '' }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.desconto.toMoeda() }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.juros.toMoeda() }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.valorFinal.toMoeda() }}</td>
                        <td style="font-size: 100% " class="text-center">{{item.formaPagamento}}</td>
                        <td style="font-size: 100% " class="text-center">{{item.projetoId}}</td>
                        <td style="font-size: 100% " class="text-left">{{ item.projeto }}</td>
                        <td style="font-size: 100% ; width: 400px" class="text-left">{{item.descricao}}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="text-center"> <b>Total Desconto:</b> </td>
                        <td colspan="2" class="text-center"> {{ item.totalDesconto.toMoeda(true) }} </td>
                        <td colspan="2" class="text-center"> <b>Total Juros: </b> </td>
                        <td colspan="2" class="text-center"> {{ item.totalJuros.toMoeda(true) }} </td>
                        <td colspan="3" class="text-center"> <b>Total Compromissos:</b> </td>
                        <td colspan="1" class="text-center"> {{ item.total.toMoeda(true) }} </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </relatorio-page>
</template>

<script>

import CompromissoService from '@/core/services/financeiro/CompromissoService';

export default {
    data(){
        return {
            overlay: false,
            empresa: {},
            compromissos: [],
            totalDesconto: 0,
            totalJuros: 0,
            total: 0,
            item: {
                compromissos: [],
                totalDesconto: 0,
                totalJuros: 0,
                total: 0
            }
        }
    },
    mounted(){

        this.overlay = true;
        
        this.sessionApp = JSON.parse(localStorage.sessionApp);
        this.empresa = {
            nomeCnpj: this.sessionApp.empresaNomeCnpj
        };

        let filter = this.$route.query;
        let compromissoService = new CompromissoService();

        compromissoService.Relatorio(filter.fornecedorId, filter.projetoId, filter.vencimentoInicial, filter.vencimentoFinal, filter.pagamentoInicial, filter.pagamentoFinal, 
        filter.emissaoInicial, filter.emissaoFinal, filter.competenciaInicial, filter.competenciaFinal, filter.numeroDocumento, filter.situacao, filter.codigoInicio, filter.codigoFim).then(
            res => {
                this.item = res.data;
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        )
        .finally(() => {
            this.overlay = false;
        });
    },
    methods: {
        Imprimir(){
            window.print();
        },
        Fechar(){
            window.close();
        }
    }
}

</script>

<style>
    .fonte{
        font-size: 90%;
    }

    .compromisso-thead > tr > th {
        color: #ffffff !important;
    }
</style>

